module.exports = __webpack_public_path__ + "media/images/village/stars-f731cab8798516007e7531028876594d.svg";